import {getOrderStateId} from "../../../../actions/actionCreators";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CancelIcon from "@material-ui/icons/Cancel";
import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import i18n from "../../../../i18nextInitiator";
import {connect} from "react-redux";
import SlideCard from "../../SlideCard";
import CancelModal from "./CancelModal";

/**
 * translate function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');

/**
 * Redux States.
 * @param state
 */
const mapStateToProps = state => ({ ...state.invoice.bill });

/**
 * JSS make styles.
 * @type {(props?: any) => ClassNameMap<"waitingText">}
 */
const useStyles = makeStyles((theme)=>{
    const errorColor = theme.palette.error.main
    const secondaryColor = theme.palette.secondary.main
    const btnRadius = ".8rem"
    const btnWidth = "95%"
    return {
        cancelBtn: {
            padding: "5px 15px",
            borderRadius: btnRadius,
            width: btnWidth,
            // float: "right"
        },
        editBtn: {
            color: secondaryColor,
            borderColor: secondaryColor,
            backgroundColor: "#faf6ee",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            padding: "5px 15px",
            borderRadius: btnRadius,
            width: btnWidth
        },
        modalRoot: {
            padding: "1rem",
            '& > *': {
                margin: ".8rem 0"
            }
        }
    }
});

/**
 * Cancel Btn and the conditions to display it.
 * @returns {JSX.Element}
 * @constructor
 */
const CancelOrder = (props) => {
    const classes = useStyles()
    const [showCancelModal, setShowCancelModal] = useState();

    /**
     * if order is not started return cancel btn.
     */
    if (props.status < getOrderStateId("started")) {
        /**
         * Return only icon when the order is assigned to a driver.
         */
        if (props.status > getOrderStateId("submitted"))
            return <>
                <IconButton onClick={()=>setShowCancelModal(true)}>
                    <CloseIcon/>
                </IconButton>

                <SlideCard
                    title={t("canceling.are-you-sure")}
                    show={showCancelModal}
                    close={()=>setShowCancelModal(false)}
                >
                    <CancelModal close={()=>setShowCancelModal(false)}/>
                </SlideCard>
            </>


        return <Grid container justifyContent={"center"}>

            {/*<Grid xs={6}>*/}
            {/*    <Button*/}
            {/*        // onClick={props.cancel}*/}
            {/*        endIcon={<CancelIcon />}*/}
            {/*        className={classes.editBtn}*/}
            {/*    >*/}
            {/*        {t("edit")}*/}
            {/*    </Button>*/}

            {/*</Grid>*/}

            <Grid item xs={6}>
                <Button
                    variant={"outlined"}
                    color={"primary"}
                    onClick={()=>setShowCancelModal(true)}
                    endIcon={<CancelIcon />}
                    className={classes.cancelBtn}
                >
                    {t("cancel-order")}
                </Button>
            </Grid>

            <SlideCard
                title={t("canceling.are-you-sure")}
                show={showCancelModal}
                close={()=>setShowCancelModal(false)}
            >
                <CancelModal close={()=>setShowCancelModal(false)}/>
            </SlideCard>
        </Grid>
    }
    return null;
}

export default connect(mapStateToProps)(CancelOrder)
